export const DEFAULT_DIRECTION_MAP = {
  2: "upRight",
  3: "upRight",
  4: "downRight",
  5: "downRight",
  6: "down",
  7: "down",
  8: "downLeft",
  9: "downLeft",
  10: "upLeft",
  11: "upLeft",
  12: "up",
};
